import { useQuery } from "react-query";
import { UserRes } from "../types";
import { generateSignedRequestConfig, getBaseUrl, handleResponse } from "../utils";

const useGetVfAvailability = (productId: number, user: UserRes) => {
  const { apiKey, apiSecret, countryCode, id } = user;

    const config = generateSignedRequestConfig({
        apiKey,
        apiSecret,
        countryCode,
        id,
        method: 'GET',
        url: `${getBaseUrl()}/api/billing/vodafone/locale/valid/${id}/product/${productId}`,
    });

    return useQuery<boolean>(
        [
            'checkVFAvailable',
            {
                config
            }
        ],
        () => fetch(config.url, { ...config }).then(res => handleResponse(res)),

        {
            enabled: true,
            retry: 0,
            staleTime: 0,
            keepPreviousData: false
        }
    );
}

export default useGetVfAvailability